export const ColorNames = {
  BLACK: "black",
  BLUE: "blue",
  GREEN: "green",
  GREY: "grey",
  MAROON: "maroon",
  ORANGE: "orange",
  RED: "red",
  TEAL: "teal",
  WHITE: "white",
  YELLOW: "yellow",
};

export const Colors = {
  WHITE: "#FFF",
  BLACK: "#1A1A24",
  //todo: update color names to actual existing
  GRAY200: "#F2F2F2",
  GRAY250: "#DEDEDE",
  GRAY600: "#3A3A4A",
  GRAY300: "#D8D8DC",
  GRAY900: "#1A1A24",
  BLUE150: "#D5EBF4",
  BLUE175: "#A9D0F4",
  BLUE125: "#E8F5FF",
  BLUE225: "#D8E8F6",

  GREY50: "#FAFAFC",
  GREY100: "#F6F6FA",
  GREY200: "#EAEAF2",
  GREY225: "#E7E7EA",
  GREY250: "#E1E1E6",
  GREY300: "#C4C4CD",
  GREY350: "#A8A8AC",
  GREY400: "#747480",
  GREY450: "#3A3A4A",
  GREY480: "#585860",
  GREY500: "#2E2E38",
  GREY550: "#2E2E3C",
  GREY600: "#23232F",
  SF_BG_GRADIENT:
    "linear-gradient(252deg, #EFEFF1 0.69%, #FFF 25.84%, #F2F3F6 52.54%, #FFF 73.08%, #F4F4F4 99.26%)",

  YELLOW400: "#FFE600",
  GREEN100: "#8CE8AD",
  GREEN300: "#34C768",
  GREEN400: "#2DB757",
  GREEN500: "#189D3E",
  GREEN600: "#168736",
  GREEN700: "#13652A",
  TEAL100: "#93F0E6",
  TEAL200: "#60E6E1",
  TEAL300: "#42C9C2",
  TEAL400: "#27ACAA",
  TEAL500: "#109090",
  BLUE50: "#F3FAFF",
  BLUE100: "#87D3F2",
  BLUE100_1: "#E0EFFA", // Todo:Get correct color name
  BLUE200: "#4EBEEB",
  BLUE300: "#35A4E8",
  BLUE300_1: "#A2DDF4",
  BLUE400: "#188CE5",
  BLUE500: "#1777CF",
  BLUE600: "#155CB4",
  BLUE700: "#082C65",
  PURPLE100: "#9C82D4",
  PURPLE200: "#724BC3",
  PURPLE300: "#542EA5",
  MAROON100: "#C981B2",
  MAROON200: "#B14891",
  MAROON300: "#922B73",
  RED100: "#FF9A91",
  RED200: "#FF736A",
  RED300: "#F95D54",
  RED400: "#FF4136",
  RED500: "#E0362C",
  RED600: "#B9251C",
  ORANGE100: "#FFB46A",
  ORANGE200: "#FF9831",
  ORANGE300: "#FF810A",
  ORANGE400: "#FF6D00",
  ORANGE500: "#F76900",
};

export const ColorMappings = [
  {
    colorName: ColorNames.BLACK,
    intensity: 1,
    backgroundColor: Colors.BLACK,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.MAROON,
    intensity: 1,
    backgroundColor: Colors.MAROON100,
    fontColor: Colors.BLACK,
  },
  {
    colorName: ColorNames.GREY,
    intensity: 1,
    backgroundColor: Colors.GREY100,
    fontColor: Colors.BLACK,
  },
  {
    colorName: ColorNames.RED,
    intensity: 1,
    backgroundColor: Colors.RED100,
    fontColor: Colors.BLACK,
  },
  {
    colorName: ColorNames.ORANGE,
    intensity: 1,
    backgroundColor: Colors.ORANGE100,
    fontColor: Colors.BLACK,
  },
  {
    colorName: ColorNames.GREEN,
    intensity: 1,
    backgroundColor: Colors.GREEN100,
    fontColor: Colors.BLACK,
  },
  {
    colorName: ColorNames.BLUE,
    intensity: 1,
    backgroundColor: Colors.BLUE100,
    fontColor: Colors.BLACK,
  },
  {
    colorName: ColorNames.PURPLE,
    intensity: 1,
    backgroundColor: Colors.PURPLE100,
    fontColor: Colors.BLACK,
  },
  {
    colorName: ColorNames.GREY,
    intensity: 2,
    backgroundColor: Colors.GREY200,
    fontColor: Colors.BLACK,
  },
  {
    colorName: ColorNames.MAROON,
    intensity: 2,
    backgroundColor: Colors.MAROON200,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.RED,
    intensity: 2,
    backgroundColor: Colors.RED200,
    fontColor: Colors.BLACK,
  },
  {
    colorName: ColorNames.ORANGE,
    intensity: 2,
    backgroundColor: Colors.ORANGE200,
    fontColor: Colors.BLACK,
  },
  {
    colorName: ColorNames.BLUE,
    intensity: 2,
    backgroundColor: Colors.BLUE200,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.PURPLE,
    intensity: 2,
    backgroundColor: Colors.PURPLE200,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.GREY,
    intensity: 2.25,
    backgroundColor: Colors.GREY225,
    fontColor: Colors.BLACK,
  },
  {
    colorName: ColorNames.GREY,
    intensity: 2.5,
    backgroundColor: Colors.GREY250,
    fontColor: Colors.BLACK,
  },
  {
    colorName: ColorNames.GREY,
    intensity: 3,
    backgroundColor: Colors.GREY300,
    fontColor: Colors.BLACK,
  },
  {
    colorName: ColorNames.MAROON,
    intensity: 3,
    backgroundColor: Colors.MAROON300,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.RED,
    intensity: 3,
    backgroundColor: Colors.RED300,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.ORANGE,
    intensity: 3,
    backgroundColor: Colors.ORANGE300,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.GREEN,
    intensity: 3,
    backgroundColor: Colors.GREEN300,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.BLUE,
    intensity: 3,
    backgroundColor: Colors.BLUE300,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.PURPLE,
    intensity: 3,
    backgroundColor: Colors.PURPLE300,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.YELLOW,
    intensity: 4,
    backgroundColor: Colors.YELLOW400,
    fontColor: Colors.BLACK,
  },
  {
    colorName: ColorNames.GREY,
    intensity: 4,
    backgroundColor: Colors.GREY400,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.RED,
    intensity: 4,
    backgroundColor: Colors.RED400,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.ORANGE,
    intensity: 4,
    backgroundColor: Colors.ORANGE400,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.GREEN,
    intensity: 4,
    backgroundColor: Colors.GREEN400,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.BLUE,
    intensity: 4,
    backgroundColor: Colors.BLUE400,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.GREY,
    intensity: 4.5,
    backgroundColor: Colors.GREY450,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.GREY,
    intensity: 4.8,
    backgroundColor: Colors.GREY480,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.GREY,
    intensity: 5,
    backgroundColor: Colors.GREY500,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.RED,
    intensity: 5,
    backgroundColor: Colors.RED500,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.ORANGE,
    intensity: 5,
    backgroundColor: Colors.ORANGE500,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.GREEN,
    intensity: 5,
    backgroundColor: Colors.GREEN500,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.TEAL,
    intensity: 5,
    backgroundColor: Colors.TEAL500,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.BLUE,
    intensity: 5,
    backgroundColor: Colors.BLUE500,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.GREY,
    intensity: 5.5,
    backgroundColor: Colors.GREY550,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.GREY,
    intensity: 6,
    backgroundColor: Colors.GREY600,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.RED,
    intensity: 6,
    backgroundColor: Colors.RED600,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.GREEN,
    intensity: 6,
    backgroundColor: Colors.GREEN600,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.BLUE,
    intensity: 6,
    backgroundColor: Colors.BLUE600,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.GREEN,
    intensity: 7,
    backgroundColor: Colors.GREEN700,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.BLUE,
    intensity: 7,
    backgroundColor: Colors.BLUE700,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.GREY,
    intensity: 0.5,
    backgroundColor: Colors.GREY50,
    fontColor: Colors.BLACK,
  },
  {
    colorName: ColorNames.WHITE,
    intensity: 1,
    backgroundColor: Colors.WHITE,
    fontColor: Colors.BLACK,
  },
  {
    colorName: ColorNames.BLUE100,
    intensity: 1,
    backgroundColor: Colors.BLUE100,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.BLUE200,
    intensity: 1,
    backgroundColor: Colors.BLUE200,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.BLUE300,
    intensity: 1,
    backgroundColor: Colors.BLUE300,
    fontColor: Colors.WHITE,
  },
  {
    colorName: ColorNames.BLUE400,
    intensity: 1,
    backgroundColor: Colors.BLUE400,
    fontColor: Colors.WHITE,
  },
];
